import {
  Calendar,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  Clock,
  Crown,
  Delete,
  ExternalLink,
  FileText,
  Grid3x3,
  Info,
  Mail,
  Maximize2,
  Mic,
  MicOff,
  Minus,
  Pencil,
  Phone,
  PhoneOff,
  Pause,
  Play,
  Plus,
  Reply,
  Sparkles,
  TriangleAlert,
  User,
  Volume2,
  X
} from "lucide-react"

const wrap = (Cmp) => (props) => <Cmp {...props} />

const I = {
  phone: wrap(Phone),
  phoneOff: wrap(PhoneOff),
  mic: wrap(Mic),
  micOff: wrap(MicOff),
  keypad: wrap(Grid3x3),
  volume: wrap(Volume2),
  user: wrap(User),
  close: wrap(X),
  minus: wrap(Minus),
  check: wrap(Check),
  checkCircle: wrap(CircleCheck),
  calendar: wrap(Calendar),
  reply: wrap(Reply),
  mail: wrap(Mail),
  sparkle: wrap(Sparkles),
  doc: wrap(FileText),
  chevR: wrap(ChevronRight),
  chevD: wrap(ChevronDown),
  chevronUp: wrap(ChevronUp),
  info: wrap(Info),
  alert: wrap(TriangleAlert),
  plus: wrap(Plus),
  pause: wrap(Pause),
  play: wrap(Play),
  clock: wrap(Clock),
  edit: wrap(Pencil),
  external: wrap(ExternalLink),
  crown: wrap(Crown),
  backspace: wrap(Delete),
  maximize: wrap(Maximize2)
}

export default I
